import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MatDatepicker, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { EmployeeDashboard } from 'app/shared/employee-dashboard-interface';
import { DatePipe } from '@angular/common';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute, Router } from '@angular/router';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-employees-dashboard',
  templateUrl: './employees-dashboard.component.html',
  styleUrls: ['./employees-dashboard.component.scss'],
  animations: fuseAnimations,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class EmployeesDashboardComponent implements OnInit {

  maxWorkingDays = 0;
  date = new FormControl(moment().date() >= 10 ? moment() : moment().subtract(1, 'months').endOf('month'));
  selectedDate = new Date().getDate() >= 10 ? new Date() : new Date(new Date().getFullYear(), new Date().getMonth(), 0);
  name: string;
  totalViolations = 0;
  totalEscalations = 0;
  totalLeaves = 0;
  resolvedViolations = 0;
  selectbydate: Date;
  dashboardGraph = [];
  totalDays = [];
  projectList = [];
  currentUser = this.parseService.instance.User.current();
  profileId = this.parseService.instance.User.current().get('profile').id;
  dashBoardData: EmployeeDashboard[] = [];
  widget5: { currentRange: string; xAxis: boolean; yAxis: boolean; gradient: boolean; legend: boolean; showXAxisLabel: boolean; xAxisLabel: string; showYAxisLabel: boolean; yAxisLabel: string; scheme: { domain: string[]; }; onSelect: (ev: any) => void; };
  widgets: Object = { 'widget5': { 'mainChart': { 'values': [{ 'name': '', 'series': [{ 'name': '', 'value': '' }] }] } } }
  yAxisTicks: any[];
  xAxisTicks: any[];
  yScaleMax = 12;
  view: any[] = [500, 500];
  userName = '';
  announcementView = false;
  currentDate = new Date();
  today = this.currentDate.getDate() >= 10 ? new Date() : new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 0);
  maxDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
  minDate = new Date();
  month = new FormControl(moment().date() >= 10 ? moment() : moment().subtract(1, 'months').endOf('month'));
  holidaysList: any;
  imgUrl = '';
  back = false;
  reportsList = [];
  totalReports = [];
  currentUserReport = [];
  empRole = '';
  barCustomColors = [];
  reportMonthName: any;
  days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

  constructor(
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private route: ActivatedRoute,
    private hardCodedValues: HardCodedValues,
    private router: Router,
    private spinner: NgxSpinnerService,
    private storageConfiguration: StorageConfiguration,
    private dateService: DateServiceService,
  ) {

    this.widget5 = {
      currentRange: 'values',
      xAxis: true,
      yAxis: true,
      gradient: false,
      legend: false,
      showXAxisLabel: true,
      xAxisLabel: 'Days',
      showYAxisLabel: true,
      yAxisLabel: 'Working Hours',

      scheme: {
        domain: ['#53BFFC']
      },
      onSelect: (ev) => {

      },
    };

  }

  /*
  ** ==========================================================
  ** On Init
  ** ==========================================================
  */
  async ngOnInit() {

    let id = '';
    this.route.params.subscribe(async params => {
      id = params['id'];
    });
    if (id) {
      this.back = true;
    }
    else {
      this.back = false;
    }
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    let proId = this.parseService.instance.User.current().get('profile').id;
    const queryInstance = this.parseService.instance.Object.extend('_User');
    const query = new this.parseService.instance.Query(queryInstance);
    this.profileId = id == undefined ? proId : id;
    query.include('profile');
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    let userId = await query.find();
    this.currentUser = userId[0];
    let profile = this.currentUser.get('profile');
    this.userName = profile.get('username');
    this.imgUrl = profile.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : profile.get('profileImageInfo').url;
    this.announcementView = id == undefined;
    await this.getHolidays(this.today);
    this.getWorkingDays(this.today);
    this.getDashboardDetails(this.today);
    this.getViolations();
    this.getProjects();
    this.getReportDetails();
  }

  async getHolidays(date) {
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    let year = new Date(date).getFullYear();
    holidayQuery.equalTo('year', year);
    this.holidaysList = await holidayQuery.find();
  }

  /*
  ** ==========================================================
  ** Get Timesheet Report Details
  ** ==========================================================
  */
  getReportDetails(): any {
    this.spinner.show();
    let filterDate = new Date();
    let condition = [];
    let type = '';
    let reports = [];
    let datePipe = new DatePipe('en-US');
    let reportDate = datePipe.transform(filterDate, 'MM/dd/yyyy');
    condition = [
      { condition: 'limit', value: 10000000 },
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'user.profile' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'ascending', value: 'rank' },
      { condition: 'equalTo', field: 'reportDate', value: reportDate },
    ];
    type = 'TimeSheetReport';
    this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
      results.forEach(element => {
        let profile = element.get('user').get('profile');
        let reporting = element.get('reportingTo');
        let reportDetails = element.get('reportDetails');
        reports.push({
          rank: element.get('rank'),
          userId: element.get('user').id,
          profileId: profile.id,
          userName: profile.get('firstName'),
          userImg: profile.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : profile.get('profileImageInfo').url,
          userMail: profile.get('officialInfo').officialEmail,
          reportingTo: reporting.get('firstName') + ' ' + reporting.get('lastName'),
          reportingToImg: reporting.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : reporting.get('profileImageInfo').url,
          role: reportDetails.role,
          department: reportDetails.department,
          location: reportDetails.location,
          startTime: reportDetails.startTime,
          onTime: reportDetails.onTime,
          eightHoursCount: reportDetails.hoursCount,
          totalWorkhours: reportDetails.workhours,
          totalPresentDays: reportDetails.presentDays,
          totalAbsentDays: reportDetails.absentDays,
        });
      });
      this.totalReports = JSON.parse(JSON.stringify(reports));
      this.reportsList = reports.slice(0, 12);
      this.spinner.hide();
      this.currentUserReport = this.totalReports.filter(x => x.profileId == this.profileId);
    });
  }

  /*
  ** ==========================================================
  ** Get Violation Details
  ** ==========================================================
  */
  getViolations() {
    const startend = this.startenddates(this.selectedDate);
    const queryInstance = this.parseService.instance.Object.extend('UserViolations');
    const query = new this.parseService.instance.Query(queryInstance);
    query.include('userProfileId');
    query.include('reportingTo');
    query.include('userProfileId.role');
    query.greaterThan('violatedDate', startend[0]);
    query.lessThan('violatedDate', startend[1]);
    query.descending('updatedAt');
    query.equalTo('userProfileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    query.find().then(results => {
      this.totalViolations = results.length;
      const dashboardValues = [];
      results.forEach(element => {
        const dashboard: EmployeeDashboard = new EmployeeDashboard();
        dashboard.userProfileId = element.get('userProfileId').id;
        dashboard.violations = element.get('violations');
        dashboard.totalViolations = dashboard.violations.length;
        dashboard.status = element.get('status');
        if (dashboard.status === 'escalated') {
          this.totalEscalations = this.totalEscalations + 1;
        } else if (dashboard.status === 'resolved') {
          this.resolvedViolations = this.resolvedViolations + 1;
        }
        dashboardValues.push(dashboard);
      });
    });
  }

  /*
  ** ==========================================================
  ** Get employees dashboard graph
  ** ==========================================================
  */
  getDashboardDetails(date) {
    this.totalLeaves = 0;
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    this.reportMonthName = monthNames[date.getMonth()];
    this.dashboardGraph = [];
    this.barCustomColors = [];

    let workHours;
    this.widgets = {
      'widget5': {
        'mainChart': {
          'values': []
        }
      }
    };
    const AttendanceDB1 = this.parseService.instance.Object.extend('UserTimeSheet');
    const query = new this.parseService.instance.Query(AttendanceDB1);
    const startend = this.startenddates(date);
    const selectedDate = new Date(new Date(startend[0]).setMonth(startend[0].getMonth() + 1)).getDate();
    const selectedMonth = new Date(new Date(startend[0]).setMonth(startend[0].getMonth() + 1)).getMonth();
    const selectedYear = new Date(new Date(startend[0]).setMonth(startend[0].getMonth() + 1)).getFullYear();

    const workStaredDate = this.currentUser.get('desktopVerfiedDate').getDate();
    const workStaredMonth = this.currentUser.get('desktopVerfiedDate').getMonth() + 1;
    const workStaredYear = this.currentUser.get('desktopVerfiedDate').getFullYear();
    this.minDate = new Date(workStaredYear, workStaredMonth, 0);

    query.equalTo('user', this.currentUser);
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.find().then(results => {
      let workinDatesSheets = [];
      const workSheets = [];
      const createdAt = [];
      const values = [];
      const days = this.getLeaveWorkingDays(new Date(date));
      const workDates = days.workDays;
      const leaveDates = days.leaveDay;
      let outTime;
      let notStartedWorkingDays = 0;
      workDates.forEach(innerElement => {
        // Find not started working days 
        if (selectedMonth + 1 === workStaredMonth && selectedYear === workStaredYear) {
          if (innerElement < workStaredDate) {
            notStartedWorkingDays += 1;
          }
        }
        workinDatesSheets = results.filter(x => new Date(x.get('createdAt')).getDate() === innerElement);
        workinDatesSheets.forEach(element => {
          workSheets.push(element);
        });
      });
      let totalNoOfLeaves = workDates.length - workSheets.length - notStartedWorkingDays;
      this.totalLeaves = totalNoOfLeaves < 0 ? 0 : totalNoOfLeaves;

      this.totalDays.forEach(day => {
        let board = this.dashboardGraph.includes(day);
        if (!board) {
          this.dashboardGraph.push({
            'name': day,
            'series': [
            ]
          });
        }
      });

      results.forEach(element => {
        const totalWorkHours = element.get('totalAttendance');
        workHours = this.secondsToHms(totalWorkHours.worktime);
        const inTime = this.formateEpoch(element.get('inTime'));
        if (element.get('outTime') == 0) {
          outTime = '';
        } else {
          outTime = this.formateEpoch(element.get('outTime'));
        }

        const createDate = element.get('createdAt');
        createdAt.push(createDate.getDate());
        let indexOfBar = this.dashboardGraph.findIndex(x => x.name == createDate.getDate());
        this.dashboardGraph[indexOfBar].series = [
          {
            'name': inTime,
            'value': workHours.includes('-') == true ? "8" : workHours
          }
        ]
      });
      // const desktopVerifiedDate =  this.currentUser.get('desktopVerfiedDate').setHours(0, 0, 0);
      // const selectedOrCurrentDate = date.getTime();
      days.workDays.forEach(workingDay => {
        let attendanceElement = this.dashboardGraph.findIndex(x => x.name == workingDay);
        if (this.dashboardGraph[attendanceElement].series.length == 0) {
          if (selectedMonth + 1 === workStaredMonth && selectedYear === workStaredYear && workStaredDate <= selectedDate) {
            if (selectedMonth + 1 === workStaredMonth && selectedYear === workStaredYear && workingDay > workStaredDate) {
              this.dashboardGraph[attendanceElement].series = [{ name: '', value: 8 }];
              this.barCustomColors.push({ "name": this.dashboardGraph[attendanceElement].series[0].name, "value": "#FF8181" });
            } else {

            }
          } else {
            this.dashboardGraph[attendanceElement].series = [{ name: '', value: 8 }];
            this.barCustomColors.push({ "name": this.dashboardGraph[attendanceElement].series[0].name, "value": "#FF8181" });
          }
        }
      });
      if (this.dashboardGraph.length > 0) {
        this.widgets = {
          'widget5': {
            'mainChart': {
              'values': this.dashboardGraph
            }
          }
        };
      }
      this.dashboardGraph.sort(function (a, b) { return a.name - b.name; });
      for (const element of this.dashboardGraph) {
        let day = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), element.name);
        let dayName = this.days[day.getDay()];
        element.name = element.name + ' ' + dayName;
      }
    });
  }

  /*
  ** ==========================================================
  ** Get Assigned Project Details
  ** ==========================================================
  */
  getProjects() {
    let projectList = [];
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
      [
        // { condition: 'equalTo', field: 'status', value: 'Assigned' },
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'project.client' },
        { condition: 'include', value: 'user' },
        { condition: 'limit', value: 1000 },
        { condition: 'equalTo', field: 'user', value: { __type: 'Pointer', className: '_User', objectId: this.currentUser.id } },
      ]).then(async results => {
        await this.getCurrentMonthWorkHours().then(hoursByProject => {
          let hoursSpent = '0';
          results.forEach(element => {
            const projectDetails = JSON.parse(JSON.stringify(element));
            let matchedProject = hoursByProject.find(project => project.id == projectDetails.project.objectId);
            if (matchedProject) {
              hoursSpent = this.secondsToHms(Math.ceil(matchedProject.actualHours / 1000));
            } else {
              hoursSpent = '0'
            }
            let project = {
              projectName: projectDetails.project.projectInfo.projectName,
              projectType: projectDetails.project.projectInfo.projectType,
              currentStatus: projectDetails.project.projectInfo.currentStatus,
              hours: hoursSpent,
              role: projectDetails.role,
              resourcesType: projectDetails.resourcesType,
              id: projectDetails.project.objectId
            };
            let isPushed = projectList.find(x => x.id == projectDetails.project.objectId);
            if (Number(hoursSpent) > 0 && isPushed == undefined) {
              projectList.push(project);
            }
          });
          this.projectList = projectList;
        });
      });
  }
  /*
    ** ==========================================================
    ** Get Current Work Hours
    ** ==========================================================
    */
  async getCurrentMonthWorkHours() {
    let projectHoursList = []
    const AttendanceDB1 = this.parseService.instance.Object.extend('UserTimeSheet');
    const query = new this.parseService.instance.Query(AttendanceDB1);
    let today = new Date();
    const startend = this.dateService.startEndDateByMonth(today);
    query.equalTo('user', this.currentUser);
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    await query.find().then(results => {
      let allProjectHours = []
      results.forEach(element => {
        let totalAttendance = element.get('totalAttendance');
        let projectDetails = totalAttendance.project;
        projectDetails.forEach(elementProject => {
          allProjectHours.push(elementProject);
        });
      });
      projectHoursList = allProjectHours.reduce(function (acc, val) {
        let o = acc.filter(function (obj) {
          return obj.id == val.id;
        }).pop() || { id: val.id, name: val.name, actualHours: 0 };

        o.actualHours += val.actualHours;
        if (acc.findIndex(x => x == o) == -1) {
          acc.push(o);
        }
        return acc;
      }, []);
    });
    return projectHoursList;
  }

  viewLeaveDetails() {
    this.router.navigate(['/leave-details', { id: this.profileId }]);
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  formateEpoch(date) {
    var datePipe = new DatePipe('en-US');
    const time = datePipe.transform(date, 'hh.mm');
    return time;
  }

  /*
  ** ==========================================================
  ** Get Holidays / Working days
  ** ==========================================================
  */
  getLeaveWorkingDays(date) {
    const d = new Date(date);
    let holidayList = this.holidaysList[0].get('dateList') == undefined ? {} : this.holidaysList[0].get('dateList');
    let holidays = holidayList[d.getMonth()];

    const leaveDays = [];
    const workingDays = [];
    const getTot = this.daysInMonth(d.getMonth(), d.getFullYear(), d.getDate());
    const sat = [];
    const sun = [];
    const a = { a1: 20 };

    for (let i = 1; i <= getTot; i++) {

      const newDate = new Date(d.getFullYear(), d.getMonth(), i);
      if (newDate.getDay() == 0) {
        sun.push(i);
      }
      if (newDate.getDay() == 6) {
        sat.push(i);
      }
      if (newDate.getDay() != 6 && newDate.getDay() != 0) {
        workingDays.push(i);
      }

    }

    sun.forEach(s => {
      leaveDays.push(s);
    });
    sat.forEach((sa, index) => {
      if (index % 2 == 0) {
        leaveDays.push(sa);
      } else {
        workingDays.push(sa);
      }
    });
    holidays.forEach(element => {
      let index = workingDays.findIndex(x => x == element);
      if (index != -1) {
        workingDays.splice(index, 1);
        leaveDays.push(element);
      }
    });
    return { workDays: workingDays.sort(function (a, b) { return a - b; }), leaveDay: leaveDays.sort(function (a, b) { return a - b; }) };
  }

  daysInMonth(month, year, date) {
    return new Date(year, month, date).getDate();
  }

  getWorkingDays(event) {
    var date = new Date(event);
    var month = date.getMonth();
    var year = date.getFullYear();
    date = new Date(year, month, 1);
    var days = [];
    const allDays = [];
    while (date.getMonth() === month) {

      // Exclude weekends
      var tmpDate = new Date(date);
      var weekDay = tmpDate.getDay(); // week day
      var day = tmpDate.getDate(); // day
      allDays.push(day);
      if (weekDay % 6) { // exclude 0=Sunday and 6=Saturday
        days.push(day);
      }

      date.setDate(date.getDate() + 1);
    }
    this.totalDays = allDays;
    let dates = this.getLeaveWorkingDays(event);
    this.maxWorkingDays = dates.workDays.length;
  }

  backlocation() {
    this.router.navigate(['employees-details']);
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.month != undefined ? this.month.value : '';
    if (ctrlValue != '') {
      ctrlValue.year(normalizedYear.year());
      this.month.setValue(ctrlValue);
    }
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + '.' + mDisplay;
  }

  async chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    let date;
    const ctrlValue = this.month.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.selectedDate = this.date.value._d;
    this.getWorkingDays(this.date.value._d);

    date = this.date.value._d;
    date = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    if ((date.getMonth() == new Date().getMonth()) && date.getFullYear() == new Date().getFullYear()) {
      date = new Date();
      this.selectedDate = date;
    }
    if (date <= new Date) {
      await this.getHolidays(date);
      this.getDashboardDetails(date);
    }
    else {
      this.totalLeaves = 0;
    }
    this.getViolations();
    this.getProjects();
  }

  dayafter(d) {
    const day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 1);
  }

  daybefore(d) {
    const day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 0);
  }

  startenddates(day) {
    const startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    const enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

}
